/**
 * Base origin for backend API calls.
 *
 * - **Local dev / SWA managed functions**: empty string → same-origin. The
 *   client requests `/api/...` against whatever host served the SPA, which is
 *   how the app worked when the API was an SWA Managed Functions backend.
 * - **Standalone Azure Functions (Option B)**: the Functions app origin
 *   (e.g. `https://secret-chat-func-xxxx.azurewebsites.net`), injected at
 *   build time via the `VITE_API_BASE_URL` environment variable. The frontend
 *   then calls the Functions app cross-origin (CORS-enabled) instead of going
 *   through the SWA reverse proxy.
 *
 * The value never has a trailing slash; callers append paths that already
 * start with `/api`. An unset/empty var keeps the previous same-origin
 * behaviour, so unit tests and local runs are unaffected.
 */
function resolveApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (typeof raw !== 'string') return '';
  const trimmed = raw.trim();
  // Normalise away a trailing slash so `${API_BASE_URL}/api/...` never
  // produces a double slash.
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
}

export const API_BASE_URL: string = resolveApiBaseUrl();
